'use client';

import { createContext, useContext, useEffect, useState } from 'react';
import { User } from 'firebase/auth';
import { useRouter } from 'next/navigation';
import { auth } from '@/lib/firebase';
import { onAuthStateChanged } from 'firebase/auth';

type AuthContextType = {
  user: User | null;
  loading: boolean;
  getAuthToken: () => Promise<string | null>;
};

const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
  getAuthToken: async () => null
});

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    console.log('[AuthContext] Inizializzazione provider');
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log('[AuthContext] Cambio stato auth:', { 
        hasUser: !!user, 
        userId: user?.uid 
      });
      
      setUser(user);
      
      // Verifichiamo il cookie
      const hasCookie = document.cookie.includes('__session');
      console.log('[AuthContext] Stato cookie:', { hasCookie });

      if (!user || !hasCookie) {
        const currentPath = window.location.pathname;
        if (!currentPath.startsWith('/auth/')) {
          console.log('[AuthContext] Redirect a login');
          router.push(`/auth/login?from=${currentPath}`);
        }
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, [router]);

  const getAuthToken = async () => {
    if (!user) return null;
    return await user.getIdToken(true);
  };

  return (
    <AuthContext.Provider value={{ user, loading, getAuthToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}